import { logger } from '@lib/logging-system';
import axios from 'axios';
import type { ZodSchema } from 'zod';

import { apiSchemas } from './apiSchemas';
import axiosClient from './axiosClientCached';
import { SimpleApiValidator } from './simple-api-validator';

// Create schema mappings for SimpleApiValidator
// SimpleApiValidator expects pattern strings, not regex objects
const schemas: Record<string, ZodSchema> = {};
Object.entries(apiSchemas).forEach(([pattern, schema]) => {
  // SimpleApiValidator expects patterns like "GET /api/v1/users/:id"
  // Only add if it's actually a ZodSchema
  if (schema && typeof schema === 'object' && 'parse' in schema) {
    schemas[pattern] = schema;
  }
});

// Initialize the Simple API Validator
export const apiValidator = new SimpleApiValidator({
  schemas,
  enabled: import.meta.env.VITE_ENABLE_API_VALIDATION === 'true',
  enableConsoleLogging: import.meta.env.VITE_API_VALIDATION_LOG_ERRORS === 'true',
  strictMode: import.meta.env.VITE_API_VALIDATION_STRICT_MODE === 'true',
  showUI: import.meta.env.VITE_API_VALIDATION_SHOW_UI !== 'false', // Default to true
  logger: {
    debug: (message: string, ...args: unknown[]) => {
      logger.debug(`[API Validator] ${message}`, ...args);
    },
    info: (message: string, ...args: unknown[]) => {
      logger.info(`[API Validator] ${message}`, ...args);
    },
    warn: (message: string, ...args: unknown[]) => {
      console.warn(`[API Validator] ${message}`, ...args);
    },
    error: (message: string, ...args: unknown[]) => {
      console.error(`[API Validator] ${message}`, ...args);
    },
  },
});

// Apply to axios instances
apiValidator.applyToAxios(axios);
apiValidator.applyToAxios(axiosClient);

// Export for use in components
export default apiValidator;
